import { render, staticRenderFns } from "./NotificationLeadsDrawer.vue?vue&type=template&id=756cb91c&"
import script from "./NotificationLeadsDrawer.vue?vue&type=script&lang=js&"
export * from "./NotificationLeadsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports